<template>
  <div>
    <div class="warp">

      <!-- 导航栏 start -->
      <el-steps :active="currentSetp" finish-status="success" simple style="margin-top: 20px">
        <el-step title="步骤 1"></el-step>
        <el-step title="步骤 2"></el-step>
        <el-step title="步骤 3"></el-step>
        <el-step title="步骤 4"></el-step>
        <el-step title="步骤 5"></el-step>
      </el-steps>
      <!-- 导航栏 end -->
      <!-- 表单 start -->
      <div class="item">
        <step_1 ref="step_1" v-show="currentSetp == 0" />
        <step_2 ref="step_2" v-show="currentSetp == 1" />
        <step_3 ref="step_3" v-show="currentSetp == 2" />
        <step_4 ref="step_4" v-show="currentSetp == 3" />
        <step_5 ref="step_5" v-show="currentSetp == 4" />
      </div>
      <!-- 表单 end -->
    </div>
  </div>
</template>
<script>
import step_1 from "./componests/step_1.vue";
import step_2 from "./componests/step_2.vue";
import step_3 from "./componests/step_3.vue";
import step_4 from "./componests/step_4.vue";
import step_5 from "./componests/step_5.vue";
import store from "@/store/index.js";
import {getptip,getCheckUserProject,getProjectFind} from "@/api/signUp";
export default {
  components: { step_1, step_2, step_3, step_4, step_5 },
  data() {
    return {
      currentSetp: 0,
      draft: {}, // 草稿类容
      project_id:'',//项目id
    };
  },
  mounted() {
    this.getTable()
    this.project_id = this.$route.query.project_id;
    if(this.project_id){
      this.getinfo();
    }else{
      this.childrenMoveCode();
    }
  },
  // watch: {
  //   "draft.project_id": {
  //     handler: function (val) {
  //       console.log(val);
  //       if (!val || val === "") {
  //         this.$confirm("动态码过期即将返回首页", {
  //           confirmButtonText: "确定",
  //           type: "warning",
  //         })
  //           .then(() => {
  //             // this.$router.push({ name: "rich" });
  //             this.$router.push('/');
  //           })
  //           .catch((error) => {
  //             console.log(error);
  //           });
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    //获得字段
    getTable(){
      getptip().then(res => {
        const data = res.data;
        // 将数据存储到 store 的 hintText 模块
        store.commit('hintText/SET_HINTTEXT', data);
      }).catch(error => {
        console.error('接口调用失败:', error)
      });
    },
    //获得项目信息
    getinfo(){
      getProjectFind({
        project_id:this.project_id
      }).then(res=>{
        this.draft = res.data.data
        this.$refs.step_1.getFather_step1(res.data.data);
        this.$refs.step_2.getFather_step2(res.data.data);
        this.$refs.step_3.getFather_step3(res.data.data);
        this.$refs.step_4.getFather_step4(res.data.data);
        this.$refs.step_5.getFather_step5(res.data.data);
      })
    },
    // 向子组件传递参数
    async childrenMoveCode() {

      let res = await getCheckUserProject()
      if (res.data.code != 1) {
        this.$message.error(res.data.msg);
        return;
      }
      if (!res.data.data.projectInfo) {
        return;
      }
      this.draft = res.data.data.projectInfo
      // 判断后端数据交给对应的子组件
      res.data.data.projectInfo.project_id = res.data.data.projectInfo.id;
      this.$refs.step_1.getFather_step1(res.data.data.projectInfo);
      this.$refs.step_2.getFather_step2(res.data.data.projectInfo);
      this.$refs.step_3.getFather_step3(res.data.data.projectInfo);
      this.$refs.step_4.getFather_step4(res.data.data.projectInfo);
      this.$refs.step_5.getFather_step5(res.data.data.projectInfo);
    },
    // 点击下一步
    doNext() {
      if (this.currentSetp <= 3) {
        this.currentSetp += 1;
      }
    },
    // 点击上一步
    doPre() {
      if (this.currentSetp >= 0) {
        this.currentSetp -= 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  width: 60%;
  margin: 0 auto;
  padding-top: 60px;
}
</style>
